export default __webpack_public_path__ + "static/media/pgmico(43).4d0ada0d.png";